import {eq, uniq} from "lodash";
// import diff from "object-diff";


// from object-diff description: "Get the minimal patch to extend objectA with to transform it into objectB"
export function objectDiff<T extends object>(a: T, b: T): Partial<T> {
  const keys = uniq(Object.keys(a).concat(Object.keys(b))) as (keyof T)[];
  const res: Partial<T> = {};
  keys.filter((key: keyof T) => {
    if (!eq(a[key], b[key])) {
      return true
    }
  }).forEach((key: keyof T) => {
    if (Object.keys(b).indexOf(key as string) !== -1) {
      res[key] = b[key];
    }
  });

  return res;
  // return diff(a, b);
}
